// extracted by mini-css-extract-plugin
export default {"container":"styles_container__atuBx","textWrapper":"styles_textWrapper__6Aq29","link":"styles_link__QYxX+"};